import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import api from '../../api/client';

const fmt = (n) => `€${(n||0).toFixed(2)}`;

export default function OrdiniCliente() {
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get('/orders').then(r => setOrders(r.data)).catch(console.error);
  }, []);

  const totalePagato = (o) => o.payments?.reduce((s,p) => s+p.importo, 0) || 0;

  const statoColor = (stato) => {
    const map = { BOZZA:'#666', CONFERMATO:'#3B82F6', 'IN LAVORAZIONE':'#F59E0B', PRONTO:'#8B5CF6', CONSEGNATO:'#A78BFA', PAGATO:'#22C55E', ANNULLATO:'#EF4444' };
    return map[stato] || '#888';
  };

  return (
    <div style={{ display:'flex', gap:'20px' }}>
      <div style={{ flex:1 }}>
        <h1 style={s.title}>I MIEI ORDINI</h1>
        <p style={s.sub}>{orders.length} ordini totali</p>

        {orders.length === 0 && (
          <div style={{ textAlign:'center', color:'var(--text-dim)', padding:'60px 0' }}>
            <Package size={40} color="var(--text-dim)"/>
            <p style={{ marginTop:'12px' }}>Nessun ordine ancora — vai al Catalogo per ordinare!</p>
          </div>
        )}

        <div style={{ display:'flex', flexDirection:'column', gap:'8px', marginTop:'20px' }}>
          {orders.map(o => {
            const pagato = totalePagato(o);
            const saldo = o.totale - pagato;
            const colore = statoColor(o.stato);
            const isOpen = selected?.id === o.id;
            return (
              <div key={o.id} style={{ ...s.orderRow, ...(isOpen ? s.orderRowSel : {}) }}
                onClick={() => setSelected(isOpen ? null : o)}>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px' }}>
                    <span style={{ fontFamily:"'Barlow Condensed'", fontWeight:'800', fontSize: 'var(--font-size-lg)' }}>{o.numero_ordine}</span>
                    <span style={{ ...s.badge, background:`${colore}20`, color:colore, borderColor:`${colore}40` }}>{o.stato}</span>
                  </div>
                  <div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)' }}>
                    {o.items?.length} articoli · {new Date(o.created_at).toLocaleDateString('it-IT')}
                  </div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800' }}>{fmt(o.totale)}</div>
                  {saldo > 0.01 ? <div style={{ fontSize:'var(--font-size-xs)', color:'#EF4444', fontWeight:'700' }}>DA PAGARE: {fmt(saldo)}</div>
                    : o.stato !== 'ANNULLATO' && <div style={{ fontSize:'var(--font-size-xs)', color:'#22C55E', fontWeight:'700' }}>✓ SALDATO</div>}
                </div>
                <span style={{ color: isOpen ? '#F4600C' : 'var(--text-dim)' }}>{isOpen ? '▼' : '▶'}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* DETTAGLIO */}
      {selected && (
        <div style={s.panel}>
          <div style={{ padding:'18px 20px', borderBottom:'1px solid var(--border)' }}>
            <div style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-lg)', fontWeight:'800' }}>{selected.numero_ordine}</div>
            <span style={{ ...s.badge, background:`${statoColor(selected.stato)}20`, color:statoColor(selected.stato), borderColor:`${statoColor(selected.stato)}40`, display:'inline-block', marginTop:'6px' }}>{selected.stato}</span>
          </div>

          <div style={{ padding:'16px 20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'12px' }}>
            {/* Articoli */}
            <div style={s.sec}>
              <div style={s.secTitle}>ARTICOLI</div>
              {selected.items?.map(item => {
                const hasStampa = item.note?.includes('STAMPA NOME:');
                return (
                  <div key={item.id} style={{ background:'var(--bg-input)', borderRadius:'8px', padding:'10px 12px', marginBottom:'6px' }}>
                    <div style={{ display:'flex', justifyContent:'space-between' }}>
                      <div>
                        <div style={{ fontWeight:'700', fontSize:'var(--font-size-sm)' }}>{item.variant?.product?.nome}</div>
                        <div style={{ display:'flex', gap:'6px', marginTop:'3px', alignItems:'center' }}>
                          <span style={s.tagliaPill}>{item.variant?.taglia}</span>
                          {hasStampa && <span style={{ fontSize: 'var(--font-size-xs)', color:'#F4600C', fontWeight:'700' }}>🖨 {item.note?.split('STAMPA NOME:')[1]?.split('|')[0]?.trim()}</span>}
                        </div>
                        {item.note && !hasStampa && <div style={{ fontSize:'var(--font-size-xs)', color:'#777', marginTop:'3px' }}>📝 {item.note}</div>}
                      </div>
                      <div style={{ textAlign:'right' }}>
                        <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800' }}>{fmt(item.prezzo_unitario_ivato * item.quantita)}</div>
                        <div style={{ fontSize: 'var(--font-size-xs)', color:'var(--text-dim)' }}>{item.quantita}× {fmt(item.prezzo_unitario_ivato)}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
              <div style={{ display:'flex', justifyContent:'space-between', paddingTop:'10px', borderTop:'1px solid var(--border)' }}>
                <span style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)', fontWeight:'700' }}>TOTALE</span>
                <span style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800' }}>{fmt(selected.totale)}</span>
              </div>
            </div>

            {/* Timeline */}
            {selected.history?.length > 0 && (
              <div style={s.sec}>
                <div style={s.secTitle}>AGGIORNAMENTI</div>
                {selected.history.filter(h => h.tipo === 'STATO' || h.tipo === 'PAGAMENTO').map((h, idx, arr) => {
                  const isLast = idx === arr.length - 1;
                  const color = h.tipo === 'PAGAMENTO' ? '#22C55E' : '#3B82F6';
                  return (
                    <div key={h.id} style={{ display:'flex', gap:'10px' }}>
                      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', width:'16px', flexShrink:0 }}>
                        <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:color, marginTop:'5px' }}/>
                        {!isLast && <div style={{ width:'2px', flex:1, background:'var(--border)', minHeight:'14px', marginTop:'2px' }}/>}
                      </div>
                      <div style={{ flex:1, paddingBottom: isLast ? 0 : '10px' }}>
                        <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text)' }}>{h.contenuto}</div>
                        <div style={{ fontSize: 'var(--font-size-xs)', color:'var(--text-dim)', marginTop:'2px' }}>
                          {new Date(h.created_at).toLocaleString('it-IT', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {selected.note && (
              <div style={s.sec}>
                <div style={s.secTitle}>NOTE</div>
                <div style={{ color:'var(--text-muted)', fontSize:'var(--font-size-sm)' }}>{selected.note}</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  title: { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub: { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'4px' },
  orderRow: { display:'flex', alignItems:'center', gap:'12px', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'10px', padding:'14px 16px', cursor:'pointer' },
  orderRowSel: { borderColor:'#F4600C50', background:'#FFF1E8' },
  badge: { padding:'2px 8px', borderRadius:'4px', fontSize: 'var(--font-size-xs)', fontWeight:'700', border:'1px solid' },
  panel: { width:'360px', flexShrink:0, background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'12px', display:'flex', flexDirection:'column', position:'sticky', top:'20px', maxHeight:'calc(100vh - 100px)', overflow:'hidden' },
  sec: { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'10px', padding:'12px 14px' },
  secTitle: { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)', marginBottom:'10px' },
  tagliaPill: { background:'var(--border)', border:'1px solid var(--border2)', borderRadius:'4px', padding:'2px 8px', fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-muted)' },
};
